import React, { useState, useEffect } from 'react';
import api from "../Api";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Popup from '../components/PopUP';
import QuillCDNEditor from '../components/QuillEditor';

const ContentManagement = () => {
  const [popupMessage, setPopupMessage] = useState("Loading page content...");
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState("");
  const [aboutUs, setAboutUs] = useState("");
  const [faq, setFaq] = useState("");
  const [privacy, setPrivacy] = useState("");

  useEffect(() => {
    const fetchDetails = async () => {
      setLoading(true);
      try {
        const response = await api.get(`/user-service/content`);
        console.log("content Details:", response.data);
        setPopupMessage("content details loaded successfully");
        setAboutUs(response.data?.about_us || "");
        setContent(response.data?.terms_condition || "");
        setPrivacy(response.data?.privacy_policy || "");
        setFaq(response.data?.faq || "");
      } catch (error) {
        console.error("content fetching content details:", error);
        setPopupMessage("content loading content details");
      }
      setLoading(false);
    };

    fetchDetails();
  }, []);


  const handleSave = async () => {
    // const payload = { aboutUs, faq, content, privacy };

    const payload =      {
        "about_us": aboutUs,
        "faq": faq,
        "terms_condition": content,
        "privacy_policy": privacy
    }

    try{
        const response = await api.post("/user-service/content", payload)
        console.log(response.data)
        setPopupMessage("Content saved successfully.")
    }
    catch(error){
        console.log("Activation error:", error);
    }

  };



  return (
    <>
      <Popup message={popupMessage} onClose={() => setPopupMessage("")} />
      <Sidebar />
      <div className="main-wrapper">
        <Header />
        <div className="content-wrapper">
          <section className="main-section spacer-y">
            <div className="container">
              <div className="row gy-4">
                <div className="col-xl-12">
                  <div className="common_main_bg_wrapper">
                    <div className="common_main_heading_wrapper">
                      <div className="vstack">
                        <h1>Content Management</h1>
                      </div>
                    </div>
                  </div>
                  <div className="outline_tab_card mt-4">
                    <nav>
                      <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <button
                          className="nav-link active"
                          id="nav-1-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-1"
                          type="button"
                          role="tab"
                          aria-controls="nav-1"
                          aria-selected="true"
                        >
                          About Us
                        </button>
                        <button
                          className="nav-link"
                          id="nav-2-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-2"
                          type="button"
                          role="tab"
                          aria-controls="nav-2"
                          aria-selected="false"
                        >
                          Terms & Conditions
                        </button>

                        <button
                          className="nav-link"
                          id="nav-3-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-3"
                          type="button"
                          role="tab"
                          aria-controls="nav-3"
                          aria-selected="false"
                        >
                           Privacy Policy
                        </button>


                        <button
                          className="nav-link"
                          id="nav-4-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-4"
                          type="button"
                          role="tab"
                          aria-controls="nav-4"
                          aria-selected="false"
                        >
                           FAQ
                        </button>

                      </div>
                    </nav>
                  </div>

                  {loading ? <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                   : (
                    <div className="tab_blk">
                      <div className="tab-content" id="nav-tabContent">
                        <div
                          className="tab-pane fade show active"
                          id="nav-1"
                          role="tabpanel"
                          aria-labelledby="nav-1-tab"
                          tabIndex="0"
                        >
                          <div className="common-outer-card">
                            <div className="common_sub_heading_wrapper">
                              <h2>About Us</h2>
                            </div>
                            <div className="common_content_blk">
                              <QuillCDNEditor value={aboutUs} onChange={setAboutUs} />

                              <div class="main_action_blk hstack gap-3 justify-content-start">
                                <button type="button" class="bg_primary_outline_btn rounded-pill">Cancel</button>
                                <button type="button" class="primary-btn rounded-pill" onClick={handleSave}>Save</button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="tab-pane fade"
                          id="nav-2"
                          role="tabpanel"
                          aria-labelledby="nav-2-tab"
                          tabIndex="0"
                        >
                          <div className="common-outer-card">
                            <div className="common_sub_heading_wrapper">
                              <h2>Terms & Conditions</h2>
                            </div>
                            <div className="common_content_blk">
                              <QuillCDNEditor value={content} onChange={setContent} />
                               <div class="main_action_blk hstack gap-3 justify-content-start">
                                <button type="button" class="bg_primary_outline_btn rounded-pill">Cancel</button>
                                <button type="button" class="primary-btn rounded-pill" onClick={handleSave}>Save</button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="tab-pane fade"
                          id="nav-3"
                          role="tabpanel"
                          aria-labelledby="nav-3-tab"
                          tabIndex="0"
                        >
                          <div className="common-outer-card">
                            <div className="common_sub_heading_wrapper">
                              <h2>Privacy Policy</h2>
                            </div>
                            <div className="common_content_blk">
                              <QuillCDNEditor value={privacy} onChange={setPrivacy} />
                              <div class="main_action_blk hstack gap-3 justify-content-start">
                                <button type="button" class="bg_primary_outline_btn rounded-pill">Cancel</button>
                                <button type="button" class="primary-btn rounded-pill" onClick={handleSave}>Save</button>
                              </div>
                            </div>
                          </div>
                        </div>


                        <div
                          className="tab-pane fade"
                          id="nav-4"
                          role="tabpanel"
                          aria-labelledby="nav-4-tab"
                          tabIndex="0"
                        >
                          <div className="common-outer-card">
                            <div className="common_sub_heading_wrapper">
                              <h2>FAQ</h2>
                            </div>
                            <div className="common_content_blk">
                              <QuillCDNEditor value={faq} onChange={setFaq} />
                              <div class="main_action_blk hstack gap-3 justify-content-start">
                                <button type="button" class="bg_primary_outline_btn rounded-pill">Cancel</button>
                                <button type="button" class="primary-btn rounded-pill" onClick={handleSave}>Save</button>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default ContentManagement;